/**
 * @author vishwadeep.kapoor
 * @Date: 2020-03-26 12:25:02
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-03-26 13:48:10
 */
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { AppWrappperHOC } from '../../Root/HOC';
import StyledLanding from '../../../components/StyledLanding';
import Container from '../../../components/Container';
import endPoints from '../../../config/endPoints';
import WhiteBackground from '../../../components/WhiteBackground';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import { utils, constants } from '../../../devUtils';

class Calculator extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
      avg_salary: '',
      time: '',
      employees: '',
      result: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCalculate = this.handleCalculate.bind(this);
  }

  handleInputChange(type, e) {
    this.setState({ [type]: utils.onlyNumbers(e.target.value) });
  }

  handleCalculate(e) {
    e.preventDefault();
    const { avg_salary, employees, time } = this.state;
    if (avg_salary && employees && time) {
      const result = (((time - 0.25) * employees * avg_salary) / 160).toFixed(2);
      this.setState({ result, errorMessage: '' });
    } else {
      this.setState({ errorMessage: constants.ALERT_FIELD_REQUIRED });
    }
  }

  renderCalculateForm() {
    const { result, avg_salary, employees, time, errorMessage } = this.state;
    return (
      <WhiteBackground style={{ marginTop: '100px' }}>
        <form className="contact-form" style={{ paddingBottom: '0px' }}>
          <h2>Zaggle Value Calculator</h2>
          <div>
            <span>Employees</span>
            <Input value={employees} className="form-control" placeholder="Number of Employees" onChange={(e) => this.handleInputChange('employees', e)} />
          </div>
          <div>
            <span>Salary</span>
            <Input value={avg_salary} className="form-control" placeholder="Avg monthly salary per employee" onChange={(e) => this.handleInputChange('avg_salary', e)} />
          </div>
          <div>
            <span>Monthly time spent (in hours)</span>
            <Input value={time} className="form-control" placeholder="Time spent per employee for reporting expenses" onChange={(e) => this.handleInputChange('time', e)} />
          </div>
          <Button
            type="primary"
            onClick={this.handleCalculate}
          >
            Calculate
          </Button>
          <br />
          {result && !errorMessage ?
            <p style={{ fontSize: '20px', fontWeight: '900', paddingTop: '10px', lineHeight: '37px' }}>
            Your monthly cost savings: ₹{result}
            </p> : <p>{errorMessage}</p>}
        </form>
      </WhiteBackground>
    );
  }

  render() {
    return (
      <StyledLanding>
        <section className="banners sm-none" style={{ backgroundImage: `url(${endPoints.SAVE_CALCULATE_BG})`, height: '28em' }}>
          <Container>
            <div className="row">
              <div className="col-md-6 animated wow fadeIn" style={{ paddingTop: '10%' }}>
                <h1 style={{ color: '#fff' }} className="white-color">Calculate your potential cost savings with Zaggle Save</h1>
                <p style={{ color: '#fff', paddingBottom: '20px' }} className="mrg-2-t"><strong className="font-bold">How much money would you be saving by automating expense management?</strong></p>

                <Button style={{ borderColor: '#fff' }} className="btn btn-success" onClick={() => window.scroll(0, 500)}>
                  Calculate Cost Savings
                </Button>
                {/* <a href="#cost-savings" style={{ borderColor: '#fff' }} className="btn btn-success">Calculate Cost Savings</a> */}
              </div>
              <div className="col-md-6"></div>
            </div>
          </Container>
        </section>
        <img src={endPoints.SAVE_CALCULATE_MOBILE} className="res-img lg-none" alt="Corporate Gift Cards" onClick={() => window.scroll(0, 500)} role="presentation" />
        <section className="default-section gray-bg2 animated wow fadeIn">
          <Container>
            <div className="row align-items-center">
              <div className="col-md-6 lg-none">
                <div id="cost-savings">
                  {this.renderCalculateForm()}
                </div>
              </div>

              <div className="col-md-6 pad-5-t">
                <p>
                  Expense management with multiple spreadsheets and receipts can be a nightmare! Every minute that your employees spend in submitting, following up, analyzing, and approving expenses can be better invested elsewhere. Traditional processes lead to manual errors that later burn time in audits and approvals.<br /><br />
                  In this hassle, businesses often don’t realize how much money they are actually losing as part of the processing costs. According to the latest Travel and Expense Management Trends Report, <br />
                </p>
                <p style={{ color: '#ed3b41', marginBottom: '10px' }} >
                  46% of organizations don&apos;t track the cost to process expense reports.
                </p>
                <p style={{ marginBottom: '25px' }}>
                  <b>So, if your company were to automate expense management with Zaggle Save, check out the savings you would be able to achieve every month. </b>
                </p>
                <h5 className="underline-left">Other business benefits of Zaggle Save:</h5>
                <ul>
                  <li>Reduced reimbursement time by two-thirds</li>
                  <li>Improved employee productivity and morale</li>
                  <li>New opportunities for cost savings</li>
                  <li>Centralized visibility and audit trails</li>
                  <li>Simplified petty cash management</li>
                  <li>Tax savings</li>
                </ul>
                <br clear="all" />
                <Link to={constants.LINK_SAVE}>
                  <Button className="btn btn-success">
                  Try Zaggle Save for Free
                  </Button>
                </Link>
                <div style={{ paddingBottom: '100px' }} />
              </div>
              <div className="col-md-6 sm-none">
                <div id="cost-savings">
                  {this.renderCalculateForm()}
                </div>
              </div>
            </div>
          </Container>
        </section>
      </StyledLanding>
    );
  }
}

const component = AppWrappperHOC(Calculator);

export { Calculator };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/Calculator/index.js